import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import useGlobalLoading from "./store/global-loading";

const App = () => {
    const { isAuthenticated, isLoading } = useKindeAuth();
    const { setIsLoading } = useGlobalLoading();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading) {
            if (isAuthenticated) {
                navigate("/app/dashboard");
            } else {
                navigate("/auth/sign-in");
            }
        }

        setIsLoading(isLoading);
    }, [isLoading, isAuthenticated, navigate, setIsLoading]);

    return null;
};

export default App;
